import { format, isBefore, isEqual } from 'date-fns';
// lodash
import get from 'lodash/get';
import includes from 'lodash/includes';
import {
  USER_AGE_CHECK,
  UPDATE_CUSTOMER_DOB,
  GET_PAYMENT_WALLET,
  SAVED_CARD_SELECTED,
} from '../../../constants/actionConstants';
import {
  URL_CUSTOMER_PAYMENT_CARDS,
  URL_UPDATE_CUSTOMER,
} from '../../../constants/endpointConstants';
import paymentTypeConstants from '../../../constants/paymentTypeConstants';
import triggerAnalyticsEvent from '../analytics/analyticsAction';
import { isPactApp } from '../../reducers/app/appReducer';

export const updateCustomerDOB = body => ({
  type: UPDATE_CUSTOMER_DOB,
  request: client => client({ path: URL_UPDATE_CUSTOMER, config: { method: 'PUT', body } }),
});

export const fetchPaymentWallet = () => async (dispatch, getState) => {
  const isSignedIn = get(getState().user, 'isSignedIn', false);
  const notFetched = !get(getState().user, 'fetchedPaymentWallet', false);
  const isPartnerDiscountEnabled = get(getState().user, 'partnerDiscountEnabled', false);

  if (isSignedIn && notFetched && !isPactApp(getState())) {
    await dispatch({
      type: GET_PAYMENT_WALLET,
      request: client => client({
        path: URL_CUSTOMER_PAYMENT_CARDS,
        config: {
          method: 'GET',
        },
      }),
      isPartnerDiscountEnabled,
    });
  }

  // TODO any point doing this for non-signed in users?
  const selectedPaymentType = get(getState().payment, 'selectedPaymentType', '');
  if (includes(selectedPaymentType, paymentTypeConstants.SAVED_CREDIT_CARD)) {
    return dispatch(triggerAnalyticsEvent(SAVED_CARD_SELECTED));
  }

  // TODO why are we even in this function if user is not signed in?
  return {};
};

export const checkAgeRestrictionDate = (date, updateCustomer) => async (dispatch, getState) => {

  const { ageCheckDate, isSignedIn } = getState().user;

  if (isEqual(date, ageCheckDate) || isBefore(date, ageCheckDate)) {
    if (isSignedIn && updateCustomer) {
      await dispatch(updateCustomerDOB({ dateOfBirth: format(date, 'YYYY-MM-DD') }));
    }

    dispatch({
      type: `${USER_AGE_CHECK}.SUCCESS`,
    });

    return;
  }

  dispatch({
    type: `${USER_AGE_CHECK}.FAILED`,
    dob: date,
  });

};
